import type {LocationQueryValue} from "#vue-router";
import type {QueryValue} from "ufo";

export const getFirstQueryValue = <T extends QueryValue | LocationQueryValue>(
  q: T | T[],
): T => {
  return Array.isArray(q) ? q[0] : q;
};

export const asString: <T extends QueryValue | LocationQueryValue>(
  q: T,
) => string | undefined = (q) => {
  return typeof q === "string" ? q : undefined;
};

export const asInt: <T extends QueryValue | LocationQueryValue>(
  q: T,
) => number | undefined = (q) => {
  if (typeof q === "number" && !isNaN(q)) {
    return q;
  }
  const _q = asString(q);
  const parsed = _q ? parseInt(_q, 10) : undefined;
  return parsed && !isNaN(parsed) ? parsed : undefined;
};
